import flatpickr from 'flatpickr';
import { Polish } from 'flatpickr/dist/l10n/pl.js';
import 'flatpickr/dist/flatpickr.min.css';

const pickers = [];

let elements = $(document).find('.datepicker-field');
if (elements.length) {
    elements.each(function (i, e) {
        initDatepicker(e)
    })
}

$(document).on("change", ".field-control", function (e) {
    let _this = $(this);
    let $form = _this.closest('form');
    let data = {};
    let url = new URL($form[0].action);
    let searchParams = new URLSearchParams(url.search);
    searchParams.forEach((value, key) => {
        if (key.startsWith('advanced_filter[')) {
            url.searchParams.delete(key);
        }
    });

    data[_this.attr('name')] = _this.val();
    $.ajax({
        url: url.toString(),
        type: $form.attr('method'),
        data: data,
        complete: function (html) {
            let id = '#' + _this.attr('id')
            let valueBlock = id.replace('_field', '_options')
            let newBlock = $(html.responseText).find(valueBlock)
            let filter = $(id.replace('_field', ''))
            let oldBlock = $(valueBlock)

            newBlock.find('.field-value').val('')

            if (oldBlock.length) {
                oldBlock.remove()
            }

            let elements = newBlock.find('.datepicker-field');
            if (elements.length) {
                elements.each(function (i, e) {
                    initDatepicker(e)
                })
            }
            filter.find('.filter-options').append(newBlock)

            $('body').find('.form-control').each(function () {
                if ($(this).val()) {
                    $(this).closest('.form-group').find('label').addClass('focused-label');
                }
            });
        }
    });
});

$(document).on('change', 'select.field-options', function () {
    const dateElement = $(this).closest('div:not(.form-group)').find('.datepicker-field');

    if (dateElement.length) {
        if ($(this).val() === '=') {
            $(dateElement).addClass('no-date-range');
        } else {
            $(dateElement).removeClass('no-date-range');
        }

        pickers[dateElement[0].getAttribute('id')].destroy();
        initDatepicker(dateElement[0]);
    }
});

$(document).on("click", ".add-filter-widget", function (e) {
    let list = $($(this).attr('data-list-selector'));
    let counter = list.data('widget-counter') || list.children().length;
    let newWidget = list.attr('data-prototype');

    let correction = Math.floor(Math.random() * 99999);
    newWidget = newWidget.replace(/__name__/g, counter+correction);
    counter++;
    list.data('widget-counter', counter+correction);

    let newElem = $(list.attr('data-widget-element')).html(newWidget);
    newElem.find('.filter-field').after(`<fieldset class='filter-options form-group'></fieldset>`);
    newElem.appendTo(list);
});

$(document).on("click", ".item-remove", function (e) {
    $(this).parents('li').remove();
});

$(document).on("click", ".reset-filter", function () {
    const url = $(this).data('reset-url');
    if (url) {
        window.location.href = url;
    }
});

$(document).on("click", ".view-change", function (e) {
    e.preventDefault();
    const basic = 'Basic search';
    let viewChange = $(this);
    let filterForm = $('.filter-form');
    let changeField = $('#advanced_filter_change');
    let basicView = viewChange.attr('data-basic');
    if (basic === changeField.val()) {
        $('.reset-filter').trigger('click');
    }
    viewChange.text(basicView)
    changeField.val(basic)
    filterForm.removeClass('basic-version');
    $('#filter-fields-list').removeClass('row');

    $('#filter-fields-list').find('.datepicker-field').each(function (i, e) {
        const operator = $(e).hasClass('no-date-range') ? '=' : 'between';
        $(e).closest('div:not(.form-group)').find('select.field-options').val(operator)
    });
});

$(document).on("click", ".comparisons", function (e) {
    choiceLogic();
});

function initDatepicker(element) {
    const operator = $($(element).closest('div:not(.form-group)').find('.form-group')[0]).find('select').val();
    const isRange = !$(element).hasClass('no-date-range') || operator === 'between';

    pickers[element.getAttribute('id')] = flatpickr(element, {
        mode: isRange ? 'range' : 'single',
        dateFormat: 'Y-m-d',
        locale: { ...Polish, rangeSeparator: ' - ' },
        onChange() {
            $(element).closest('.form-group').find('label').addClass('focused-label');
        },
    });
}

function choiceLogic() {
    const all = 'all';
    const any = 'any';
    const logical = $('#advanced_filter_logical');
    let comparisons = $('.comparisons');

    if (all === logical.val()) {
        logical.val(any);
        comparisons.text(comparisons.attr('data-any'));
        return;
    }
    logical.val(all)
    comparisons.text(comparisons.attr('data-all'));
}
